module.exports = __webpack_public_path__ + "static/custom-script-per-machine-9319e751e0f04b0dd8bea172d35f2965.png";